import sale from './sale/routes'

const scrappingRoutes = {
  index: {
    path: 'index.scrapping',
    url: 'ferraillage',
  },
  sale: sale,
}

export default scrappingRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/routes.js